import React from "react";
import { Card, Typography } from "antd";

interface DashboardCardType {
    title?: string;
    contents?: string | number;
    description?: string;
    hoverable?: boolean;
    actions?: React.ReactNode[];
    onCardClick?: React.MouseEventHandler<HTMLDivElement>;
}

const DashboardCard: React.FC<DashboardCardType> = ({ title, contents, description, hoverable, actions, onCardClick }) => {
    return (
        <Card
            hoverable={hoverable}
            actions={actions}
            onClick={onCardClick}
            style={{ height: '100%' }}
        >
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px',
            }}>
                <div>
                    <Typography.Title level={2} style={{ margin: 0 }}>{title || ""}</Typography.Title>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <Typography.Title level={1} style={{ color: '#FF8300', margin: 0 }}>{contents || ""}</Typography.Title>
                    <Typography.Text type="secondary" style={{ margin: 0 }}>{description || ""}</Typography.Text>
                </div>
            </div>
        </Card>
    );
}

export default DashboardCard;